<template>
  <div class="breadcrumbs sml-hide">
    <template
        v-for="item in items"
    >
      <a class="breadcrumbs__item breadcrumbs__item_link"
         :href="item.url"
         :title="item.text"
      >{{ item.text }}</a>
    </template>
    <span class="breadcrumbs__item">{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: {
    items: [],
    name: ''
  },
}
</script>

<style scoped>

</style>